import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import BackendRoutes from '@/router/backend-route'
import FrontendRoutes from '@/router/frontend-route'
import buefy from 'buefy'
import 'buefy/dist/buefy.css';

// import "@/myBuefyStyle/myBuefyStyle.scss";
import Config from './config';

import axios from "axios";
Vue.prototype.$http = axios;

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(buefy)

Vue.prototype.$base_url=Config.base_url
Vue.prototype.$customer_url=Config.customer_url
Vue.prototype.$base_public_url=Config.base_public_url

var allRoutes = []
allRoutes = allRoutes.concat(BackendRoutes,FrontendRoutes)

const router = new VueRouter({
  routes:allRoutes,
  mode:"history"
})

new Vue({
  render: h => h(App),
  router:router,
  data:{
    //agent data properties
    agentAuthToken:'',
    file_url:'',
    agent_location_data:[],
    agent_ip_address:'',
    agentEmail:'',
    AgentForgetPasssowrdEmail:'',
    agentContactNumber:'',
    agentName:'',
    user_role:'',
    user_id:'',

    // invitee data properties ----------------------
    addSignatureOTP:'',
    invitee_token:'',
    customerData:[],
    location_data:[],
    invitee_ip_address:'',
    Errors:[],
    invitee_document_id:''
  }
}).$mount('#app')